// removed by extract-text-webpack-plugin
module.exports = {"link":"_1dfPekctHKcgGUixmna6Hb","orange":"iNu1kog6hL4teBS2_T3OP","gray":"pMgIrL0NVc17TPlEGCkOh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Link/style.css
// module id = 218
// module chunks = 42